import {Logger} from '@feature-hub/core';
import {DrivingProfile} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';

export type DrivingProfileVector = [number, number, number];
const DEFAULT_DRIVING_PROFILE: DrivingProfileVector = [34, 31, 35];

export const getDefaultDrivingProfile = (
  appDataContentValue: DrivingProfile<string>[] | undefined,
  acsValue?: DrivingProfile,
  logger?: Logger
): DrivingProfileVector => {
  const validateAndReturn = (
    valueCity: any,
    valueCountry: any
  ): DrivingProfileVector | undefined => {
    // CMS limitation - we must receive string values and parse to number
    const parsedCityValue =
      typeof valueCity === 'string' ? Number(valueCity) : valueCity;
    const parsedCountryValue =
      typeof valueCountry === 'string' ? Number(valueCountry) : valueCountry;

    if (
      Number.isInteger(parsedCityValue) &&
      Number.isInteger(parsedCountryValue) &&
      parsedCityValue >= 0 &&
      parsedCountryValue >= 0 &&
      parsedCityValue + parsedCountryValue <= 100
    ) {
      return [
        parsedCityValue,
        parsedCountryValue,
        100 - parsedCityValue - parsedCountryValue,
      ];
    } else {
      logger?.warn(
        `Invalid driving profile values: city='${valueCity}', country='${valueCountry}'. Both must be whole numbers and sum to 100 or less.`
      );
      return undefined;
    }
  };

  if (appDataContentValue?.length) {
    const valueCity = appDataContentValue[0].city.trim();
    const valueCountry = appDataContentValue[0].country.trim();

    const validAppDataValue = validateAndReturn(valueCity, valueCountry);
    if (validAppDataValue !== undefined) return validAppDataValue;
  }

  const validAcsValue =
    acsValue !== undefined
      ? validateAndReturn(acsValue.city, acsValue.country)
      : undefined;
  if (validAcsValue !== undefined) return validAcsValue;

  return DEFAULT_DRIVING_PROFILE;
};
